import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OnboardingStore } from '../onboarding.store';
import { SignupService } from '../../../tpiq-services/signup.service';
import { AddUserService } from '../../../tpiq-services/add-user.service';
import { ToastService } from '../../../services/Toast.service';
import { TOAST_TYPE } from '../../../constants/Tpiq.constants';
import { Session } from '../../../services/Session';
import { isValidEmail, hasDangerousContent } from '../../../utils/validators';

@Component({
  selector: 'app-invite-step',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './invite-step.component.html',
})
export class InviteStepComponent {
  readonly hasDangerousContent = hasDangerousContent;
  readonly isValidEmail        = isValidEmail;

  inviteMembers: Array<{ name: string; email: string }> = [
    { name: '', email: '' },
  ];

  private org    = Session.getOrg();
  private userId = Session.getUser().id;

  constructor(
    private store: OnboardingStore,
    private signupService: SignupService,
    private addUserService: AddUserService,
    private toastService: ToastService,
  ) {}

  get atInviteLimit(): boolean {
    return this.inviteMembers.length >= this.store.maxInvites();
  }

  addMember() {
    if (!this.atInviteLimit) {
      this.inviteMembers.push({ name: '', email: '' });
    }
  }

  removeMember(index: number) {
    this.inviteMembers.splice(index, 1);
  }

  skip() {
    this.signupService.updateCompanyOnboarding(this.org, this.userId, 'Done').subscribe({ error: () => {} });
    this.store.nextStep();
  }

  save() {
    this.signupService.updateCompanyOnboarding(this.org, this.userId, 'Done').subscribe({ error: () => {} });
    this.sendInvites();
    this.store.nextStep();
  }

  private sendInvites() {
    const validMembers = this.inviteMembers.filter(m =>
      m.email && isValidEmail(m.email) && !hasDangerousContent(m.name)
    );
    if (validMembers.length === 0) { return; }
    const payload = validMembers.map(m => {
      const spaceIdx = m.name.indexOf(' ');
      const firstName = spaceIdx >= 0 ? m.name.slice(0, spaceIdx) : m.name;
      const lastName  = spaceIdx >= 0 ? m.name.slice(spaceIdx + 1) : '';
      return { firstName, lastName, id: m.email };
    });
    this.addUserService.addUser(payload).subscribe({
      error: (error) => {
        this.toastService.pop(TOAST_TYPE.error, error.message || 'Some invitations could not be sent.');
      }
    });
  }
}
